import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table";
import React from "react";
import { Button } from "reactstrap";
import { connect } from "react-redux";
import {
  showEditSubscriptionModal,
  showRemoveSubscriptionModal,
} from "../../../store/financialSettings/actions";
import {
  dateHelper,
  isValidFee,
} from "../../../helpers/financial_settings_helper";
import { useTextFilter } from "helpers/textFilter";

// No name/title field exists on a subscription — the only text this table
// shows is the amount and its validity dates, so that's what's searchable.
const subscriptionSearchFields = (subs) => [
  subs.feeAmount,
  dateHelper(subs.validFrom, "DD/MM/YYYY"),
  dateHelper(subs.validTo, "DD/MM/YYYY"),
];

// feeAmount: joi.number().min(0).required(),
//   currency: joi
// .string()
// .uppercase()
// .valid(...Object.values(supportedCurrencies)),
//   validFrom: joi.date(),
//   validTo: joi.date(),
const SubscriptionsList = ({
  subscriptionList,
  searchQuery,
  showEditSubscriptionModal,
  showRemoveSubscriptionModal,
}) => {
  const visibleSubscriptionList = useTextFilter(subscriptionList, subscriptionSearchFields, searchQuery);

  return (
    <div className="table-rep-plugin">
      <div className="table-responsive mb-0" data-pattern="priority-columns">
        <Table
          id="transaction-fees"
          className="table table-striped table-bordered"
        >
          <Thead>
            <Tr>
              <Th data-priority="1">Валиден</Th>
              <Th data-priority="1">Сума</Th>
              <Th data-priority="2">Валиден от</Th>
              <Th data-priority="2">Валиден до</Th>
              <Th data-priority="3">Създаден на</Th>
              <Th data-priority="3">Обновен на</Th>
              <Th data-priority="4">Действия</Th>
            </Tr>
          </Thead>
          <Tbody>
            {visibleSubscriptionList.map((subs) => {
              const isValid = isValidFee(subs.validFrom, subs.validTo);
              return (
                <Tr key={subs._id}>
                  <Td className={`${isValid ? "bg-success" : "bg-warning"}`}>
                    {isValid ? "Да" : "Не"}
                  </Td>
                  <Td>{subs.feeAmount}</Td>
                  <Td>{dateHelper(subs.validFrom, "DD/MM/YYYY")}</Td>
                  <Td>{dateHelper(subs.validTo, "DD/MM/YYYY")}</Td>
                  <Td>{dateHelper(subs.createdAt)}</Td>
                  <Td>{dateHelper(subs.updatedAt)}</Td>
                  <Td>
                    <div className="button-items">
                      <Button
                        title="Изтрий абонамента"
                        color="danger"
                        type="button"
                        className="waves-effect waves-light"
                        onClick={() => {
                          showRemoveSubscriptionModal(subs._id);
                        }}
                      >
                        <i className="bx bx-trash-alt font-size-16 align-middle"></i>
                      </Button>
                      <Button
                        title="Редактирай абонамента"
                        type="button"
                        color="primary"
                        className="waves-effect waves-light"
                        onClick={() => {
                          showEditSubscriptionModal(subs._id);
                        }}
                      >
                        <i className="bx bxs-edit font-size-16 align-middle"></i>
                      </Button>
                    </div>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
        {/*<pre>{JSON.stringify(list, null, 2)}</pre>*/}
      </div>
    </div>
  );
};

const mapStateToProps = ({ FinancialSettings }) => {
  return FinancialSettings;
};

export default connect(mapStateToProps, {
  showEditSubscriptionModal,
  showRemoveSubscriptionModal,
})(SubscriptionsList);
